import * as React from "react";

interface ListProps<T> {
    items: readonly T[];
    children: (item: T, index: number) => React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const SimpleList = <T extends unknown>({ items, children: render }: ListProps<T>) => {
    return <React.Fragment>{items.map(render)}</React.Fragment>;
};

export default SimpleList;
